import { APIHandler, DataHandler, StorageHandler } from 'C4';
import { storageKeys } from 'settings';

export default class ProgressHandler {
  constructor(params) {
    this.progress = params.progress;
    this.chapter = +params.chapter;
    this.page = +params.page;
    this.pageCount = params.pageCount;
  }

  verifyChapter() {
    return this.progress.some(chapter => +chapter.chapter === +this.chapter);
  }

  verifyPage() {
    return this.page >= 0 && this.page <= this.pageCount;
  }

  update(override) {
    return new Promise((resolve, reject) => {
      const { chapter, index } = this.getChapter(this.chapter);

      const newProgress = chapter;
      if (this.page > newProgress.progress) {
        newProgress.progress = this.page;
      }
      if (this.page + 1 === this.pageCount) {
        newProgress.progress = this.pageCount;
      }
      newProgress.percentage = (newProgress.progress / newProgress.total_pages) * 100;

      if (this.page + 1 === this.pageCount) {
        newProgress.last_page = this.pageCount;
      } else if (this.page - 1 < 0) {
        newProgress.last_page = 0;
      } else {
        newProgress.last_page = this.page;
      }

      const allValid = Object.values(newProgress).every(param => param !== undefined && param !== null);
      let updateInfo = {};

      if (allValid) {
        this.progress.data[0].chapters[index] = newProgress;
        StorageHandler.save(storageKeys.progress, this.progress);

        StorageHandler.load(storageKeys.user).then((user) => {
          updateInfo = {
            chapterId: +chapter.chapter,
            lastPage: +newProgress.last_page,
            progress: +newProgress.progress,
            email: user.response.email,
          };
          if (override !== undefined) {
            updateInfo = {
              chapterId: override.chapterId,
              lastPage: override.lastPage,
              progress: override.progress,
              email: user.response.email,
            };
          }
          APIHandler.setUserProgress(updateInfo).then(() => {
            resolve(this.progress);
          });
        });
      }
      setTimeout(() => {
        const info = {
          message: 'Operation timed out',
          allValid,
          newProgress,
          updateInfo,
          progress: this.progress,
        };
        reject(new Error(info));
      }, 5000);
    });
  }

  getChapter(chapterId) {
    const { chapters } = this.progress.data[0];
    let obj = {};
    Object.keys(chapters).forEach((index) => {
      if (+chapters[index].chapter === +chapterId) {
        obj = { chapter: chapters[index], index: +index };
      }
    });
    return obj;
  }

  pageIsAccessible(ignoreProgess) {
    const chapter = this.getChapter(this.chapter);
    const { chapter: id, progress, last_page: lastPage } = chapter.chapter;

    const rootPage = `/main/training/chapter/${id}/0`;

    if ((lastPage - 1 === this.pageCount || lastPage === null) && !window.location.href.includes(rootPage) && !ignoreProgess) {
      window.location = rootPage;
    }

    if (progress < this.page && !ignoreProgess && lastPage !== null) {
      return { valid: false, target: `/main/training/chapter/${id}/${lastPage}` };
    }
    if (progress >= this.page) {
      return { valid: true, target: '' };
    }
    return { valid: true, target: '' };
  }
}
